import React from 'react';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';

function withEventTrackingLogEvent(eventTrackingProperties, WrappedComponent) {
  const {
    nodeName,
    isPageView,
    pageViewEventProperties,
  } = eventTrackingProperties;

  return function EventTracking({ ref: refProp, ...rest }) {
    const EventTrackingProps = useEventTrackingLogEvent({
      ref: refProp,
      nodeName,
      isPageView,
      pageViewEventProperties,
    });

    return (
      <WrappedComponent
        {...rest}
        EventTracking={EventTrackingProps}
      />
    );
  };
}

export default withEventTrackingLogEvent;
